import React, { useState } from 'react';
import Button from '../common/Button';

const CheckInButton = ({ reservationId, onCheckIn }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleCheckIn = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3001'}/api/reservations/${reservationId}/checkin`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to check in');
      }

      const result = await response.json();
      
      // Show success message
      alert('Successfully checked in! Enjoy your training session.');
      
      // Callback to update parent component
      if (onCheckIn) {
        onCheckIn(result);
      }
    } catch (error) {
      console.error('Check-in error:', error);
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col">
      <Button
        onClick={handleCheckIn}
        variant="success"
        size="small"
        loading={isLoading}
        disabled={isLoading}
      >
        {isLoading ? 'Checking In...' : 'Check In'}
      </Button>
      
      {error && (
        <div className="mt-2 text-sm text-red-600">
          {error}
        </div>
      )}
    </div>
  );
};

export default CheckInButton;